import React from "react";
import BreadcrumbHead from "../../../../Components/BreadcrumbHead/BreadcrumbHead";
import Footer from "../../../../Components/Footer/Footer";
import Navbar from "../../../../Components/Navbar/Navbar";
import Introduction from "../Components/Introduction";
import { useLocation } from "react-router-dom";

const descriptions = [
  "Introducing TAMWWIL, the pioneering Algerian platform dedicated to streamlining the search and request process for top-tier financing offers. Serving both individuals and businesses, TAMWWIL ensures a safe and swift journey to securing the best loan options available. Our partnership has revolutionized the financial search process, bringing efficiency and reliability to the forefront.",
];
const linkText =
  "Discover how TAMWWIL transforms financial solutions with efficiency and reliability";

function TamwwilProjectDetail() {
  const location = useLocation();
  const { state: project } = location;
  return (
    <>
      <Navbar />
      <BreadcrumbHead title={"Tamwwil"} />
      <Introduction
        src={project.imagePath}
        linkText={linkText}
        linkUrl={project.linkUrl}
        appStoreUrl={project.appStoreUrl}
        googlePlayUrl={project.googlePlayUrl}
        descriptions={descriptions}
      />
      <Footer />
    </>
  );
}

export default TamwwilProjectDetail;
